import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/trova-cantieri/frontend/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
// User Model
import VuexORM from '@vuex-orm/core';
import Vue from 'vue';
import City from "./City";
import Subscription from "./Subscription";
import Contact from "./Contact";
var Company = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(Company, _VuexORM$Model);
  var _super = _createSuper(Company);
  function Company() {
    _classCallCheck(this, Company);
    return _super.apply(this, arguments);
  }
  _createClass(Company, [{
    key: "personalContact",
    get: function get() {
      return Contact.query().where('company_id', this.id).where('personal_contact', true).first();
    }
  }, {
    key: "dataCompleted",
    get: function get() {
      return this.billing_name && this.billing_email && (this.billing_vat_id || this.billing_tax_code) && this.billing_address && this.billing_city && this.billing_zip_code;
    }
  }, {
    key: "$getStripeSetupIntent",
    value: function $getStripeSetupIntent() {
      return Vue.prototype.$axios.get('/api/companies/' + this.id + '/get-stripe-setup-intent');
    }
  }, {
    key: "$updatePaymentMethod",
    value: function $updatePaymentMethod(paymentMethod) {
      var _this = this;
      return Vue.prototype.$axios.post('/api/companies/' + this.id + '/update-payment-method', {
        payment_method: paymentMethod
      }).then(function (response) {
        Company.update({
          where: _this.id,
          data: response.data.company
        });
        return response.data;
      });
    }
  }, {
    key: "$subscribe",
    value: function $subscribe(slug) {
      return Vue.prototype.$axios.post('/api/companies/' + this.id + '/subscribe', {
        slug: slug,
        success_url: process.env.BASE_URL + '/#/subscription',
        cancel_url: process.env.BASE_URL + '/#/subscription'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        throw error;
      });
    }
  }, {
    key: "$switchPlan",
    value: function $switchPlan(slug) {
      return Vue.prototype.$axios.post('/api/companies/' + this.id + '/switch-plan', {
        slug: slug,
        return_url: process.env.BASE_URL + '/#/subscription'
      }).then(function (response) {
        return response.data;
      }).catch(function (error) {
        throw error;
      });
    }
  }], [{
    key: "entity",
    get:
    // This is the name used as module name of the Vuex Store.
    function get() {
      return 'companies';
    }

    // List of all fields (schema) of the user model. `this.attr` is used
    // for the generic field type. The argument is the default value.
  }, {
    key: "fields",
    value: function fields() {
      return {
        id: this.attr(null),
        name: this.attr(null),
        slug: this.attr(null),
        email: this.attr(null),
        route: this.attr(null),
        zip_code: this.attr(null),
        city_id: this.number(null),
        city: this.belongsTo(City, 'city_id'),
        vat_id: this.attr(null),
        tax_code: this.attr(null),
        phone_number: this.attr(null),
        mobile_phone_number: this.attr(null),
        website: this.attr(''),
        description: this.attr(''),
        bathrooms: this.attr(null),
        construction_id: this.attr(null),
        logo: this.attr(null),
        logo_res: this.attr(null),
        stripe_id: this.attr(''),
        card_brand: this.attr(''),
        card_last_four: this.attr(''),
        trial_ends_at: this.attr(''),
        billing_name: this.attr(''),
        billing_address: this.attr(''),
        billing_email: this.attr(''),
        billing_zip_code: this.attr(''),
        billing_city_id: this.attr(''),
        billing_city: this.belongsTo(City, 'billing_city_id'),
        billing_vat_id: this.attr(''),
        billing_taxcode: this.attr(''),
        billing_phone_number: this.attr(''),
        billing_website: this.attr(''),
        billing_sdi: this.attr(''),
        sdi: this.attr(''),
        pec: this.attr(''),
        subscribed: this.boolean(false),
        pro: this.boolean(false),
        is_trial: this.boolean(false),
        subscriptions: this.hasMany(Subscription, 'company_id'),
        subscriptionType: this.attr(null),
        contacts: this.hasMany(Contact, 'company_id'),
        personal_contact: this.hasOne(Contact, 'company_id') // +++ NOTICE: do not use this field, it is only used to populate the store +++
      };
    }
  }, {
    key: "$getBySlug",
    value: function $getBySlug(slug) {
      return this.api().get('/api/companies/slug/' + slug).then(function (result) {
        return result.response;
      });
    }
  }]);
  return Company;
}(VuexORM.Model);
export { Company as default };